import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { sendStaffAppMetaData } from '../../eventTriggers'

export default function EmploymentHistory() {
  const { occupations } = useSelector(state=>state)
  const tabDefaultMetaData = useSelector(state=>state.config.tab_default_meta_data.find(tab=> tab.detail == 'employment_history'))
  const dispatch = useDispatch()

  function handleClick(resource) {
    dispatch({
      type: "EDIT_RESOURCE",
      payload: {
        resourceName: "occupation",
        resource
      }
    })
    sendStaffAppMetaData(tabDefaultMetaData.modal)
  }
  return (
    <div>
      {
        occupations.map(occupation=>(
          <div onClick={()=>handleClick(occupation)} key={occupation.id} className="p-4 border-bottom">
            <div className="d-flex justify-content-between align-items-center">
              <b>
                {occupation.position}
                { !!occupation.kind && ` (${occupation.kind})` }
              </b>
              {
                !!occupation.ended_at ? 
                <div className="badge badge-secondary">Previous</div> :
                <div className="badge badge-success">Current</div>
              }
            </div>
            <div>{occupation.employer}</div>
          </div>
        ))
      }
    </div>
  )
}
